import type { SVGProps } from 'react';
const SvgDeleteOutlinedSmall = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={18} height={18} fill="none" {...props}>
    <path
      fill="currentColor"
      fillOpacity={0.45}
      d="M5.946 2.409h-.16c.088 0 .16-.072.16-.16zh6.107v-.16c0 .088.072.16.16.16h-.16v1.446h1.446V2.248c0-.709-.576-1.286-1.285-1.286H5.785C5.076.962 4.5 1.54 4.5 2.248v1.607h1.447zM16.07 3.855H1.928a.64.64 0 0 0-.643.643v.643c0 .088.072.16.16.16H2.66l.496 10.507a1.287 1.287 0 0 0 1.284 1.226h9.12c.688 0 1.252-.538 1.284-1.226l.497-10.506h1.213c.088 0 .16-.073.16-.161v-.643a.64.64 0 0 0-.642-.643m-2.666 11.733H4.594L4.108 5.301h9.783z"
    />
  </svg>
);
export default SvgDeleteOutlinedSmall;
